var React = require('react');

function InfoColor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#8bd3e6;}.cls-2{fill:#081319;}")),React.createElement("title",{"key":1},"info-circle-colour"),React.createElement("path",{"data-style":"background","d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Z","key":2}),React.createElement("path",{"d":"M15.75,16.72V14.46h2.5v10h-2.5Z","key":3}),React.createElement("circle",{"cx":"17","cy":"10.51","r":"1.5","key":4})]);
}

InfoColor.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = InfoColor;

InfoColor.default = InfoColor;
